import { NgModule } from '@angular/core'
import { AnchorFeatureModule } from './anchor/anchor-feature.module'
import { AccordionRowFeatureModule } from './accordion-row/accordion-row-feature.module'
import { AnchorHeadlineFeatureModule } from './anchor-headline/anchor-headline-feature.module'
import { CallToActionButtonModule } from './call-to-action-button/call-to-action-button.module'
import { CentralizedButtonFeatureModule } from './centralized-button/centralized-button-feature.module'
import { ColorTableFeatureModule } from './color-table/color-table-feature.module'
import { DownloadLinkWithIconFeatureModule } from './download-link-with-icon/download-link-with-icon-feature.module'
import { ImageLandingPagesFeatureModule } from './image-landing-pages/image-landing-pages-feature.module'
import { LinkFeatureModule } from './link/link-feature.module'
import { LinkWrapperFeatureModule } from './link-wrapper/link-wrapper-feature.module'
import { PdfDownloadIconFeatureModule } from './pdf-download-icon/pdf-download-icon-feature.module'
import { PictureFeatureModule } from './picture/picture-feature.module'
import { ProductLinkFeatureModule } from './product-link/product-link-feature.module'
import { SeparatorFeatureModule } from './separator/separator-feature.module'
import { TeaserBoxFeatureModule } from './teaser-box/teaser-box-feature.module'
import { VideoLinkFeatureModule } from './video-link/video-link-feature.module'
import {
  CALL_TO_ACTION_CONVERTER_TOKEN, CallToActionButtonConverter
} from './call-to-action-button/call-to-action-button.component.converter'
import { FsComponentConverter } from 'fs-spartacus-common'
import { IconWithCircleFeatureModule } from './icon-with-circle/icon-with-circle-feature.module'
import { IconFeatureModule } from './icon/icon-feature.module'

@NgModule({
  imports: [
    AccordionRowFeatureModule,
    AnchorFeatureModule,
    AnchorHeadlineFeatureModule,
    CallToActionButtonModule,
    CentralizedButtonFeatureModule,
    ColorTableFeatureModule,
    DownloadLinkWithIconFeatureModule,
    ImageLandingPagesFeatureModule,
    LinkFeatureModule,
    LinkWrapperFeatureModule,
    PdfDownloadIconFeatureModule,
    PictureFeatureModule,
    ProductLinkFeatureModule,
    SeparatorFeatureModule,
    TeaserBoxFeatureModule,
    VideoLinkFeatureModule,
    IconFeatureModule,
    IconWithCircleFeatureModule,
  ],
  providers: [
    {
      provide: CALL_TO_ACTION_CONVERTER_TOKEN,
      useExisting: CallToActionButtonConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        call_to_action_button: CALL_TO_ACTION_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class SharedComponentsRootModule {
}
